import React from 'react';
import {
  CardWithoutBg,
} from 'libs/growth-platform-brand-system-v2/src/layouts/CardWithoutBg';
import {
  ButtonTracking,
} from 'libs/growth-platform-brand-system-v2/src/utils/tracking/ButtonTracking';
import { morphism } from 'morphism';
import { schemaCardWithoutBg } from '../morphismSchema/layouts/schemaCardWithoutBg';
import { schemaCardButtonLink } from '../morphismSchema/schemaCardButtonLinkProps';
import { readArticle } from './utils';

interface LastAticlesCardsProps {
  lastArticles: any[];
  locale: string;
  screenSize: string;
  isBlogArticle?: boolean;
}
export const getLastAticlesCards = ({
  lastArticles,
  locale,
  screenSize,
  isBlogArticle = false,
}: LastAticlesCardsProps) =>
  lastArticles?.map((article, index) => {
    const { button, linkAttributes, ...linkProps } =
      !article.doNotCreatePage &&
      morphism(schemaCardButtonLink, {
        ctaButton: {
          internalUrl: {
            slug: article.slug,
          },
          locale,
          title: readArticle[locale],
        },
        locale,
        isBlogArticle,
        screenSize,
      });

    const cta = morphism(schemaCardWithoutBg, {
      ...linkProps,
      title: article.metaFields?.title,
      subtitle: article.metaFields?.description,
      image: article.hero?.[0]?.image,
      ctaButton: button?.props,
      locale,
    });
    return (
      <ButtonTracking
        component={CardWithoutBg}
        section="articleLink"
        index={index}
        {...cta}
        labelTracking={cta}
        {...linkAttributes}
        className="w-full px-12 py-20"
        key={article.id}
        displaySubtitleOnSmallDevice={false}
      />
    );
  });
